import { isExclusiveOpenInFlight } from './exclusiveOpenInFlight';

export async function shouldSuppressRendererPlayResend(
  exclusiveActive: boolean,
  shouldUseExclusive: () => Promise<boolean>,
): Promise<boolean> {
  return isExclusiveOpenInFlight() || exclusiveActive || (await shouldUseExclusive());
}
